
import React, { Component } from 'react';

import Page from './Page';
import MarkdownContent from './MarkdownContent';

class MarkdownPage extends Component {

    render() {
        return (
            <Page>
                <MarkdownContent url={`${this.props.fileName}`}/>
            </Page>
        );
    }
}

export default MarkdownPage;
